import {AfterViewInit, Component, OnInit} from '@angular/core';
import {ApiService} from '../../services/api-service/api.service';
import * as $ from 'jquery';

@Component({
  selector: 'app-page-portfolio',
  templateUrl: './page-portfolio.component.html',
  styleUrls: ['./page-portfolio.component.scss']
})
export class PagePortfolioComponent implements OnInit, AfterViewInit {
  
  public portfolio: any[];
  public static: string;

  constructor(private apiService: ApiService) {
    this.portfolio = this.apiService.portfolio;
    this.static = this.apiService.static_link;
    setTimeout(function(){        
      $('.app-loading').css('display','flex');
      $('.app-loading').delay(1000).fadeOut('slow'); 
  }, 0);

  }

 
  ngOnInit() {
  }
  ngAfterViewInit(): void {


  }

}
